import React, {
  Dispatch,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import closeIco from "../../assets/close-icon-color.png";
import { ItemTypes, PopupsListType } from "./RightSideMenu";
import {
  airQualityMap,
  AirQualitySensor,
  openMarkers,
  openWindowsAirQualityMap,
} from "../../mainLayer/airQuality/airQuality";
import SideAirQualityChart from "../../mainLayer/airQuality/SideAirQualityChart";
import { ResizeCallbackData } from "react-resizable";
import ReactDOM from "react-dom";
import Overlay from "ol/Overlay";
import { map } from "../../mainLayer/MainLayer";
import { Coordinate } from "ol/coordinate";
import AirQualityPopup from "../../mainLayer/airQuality/airQualityPopup";
import { useRainfallContext } from "../../provider/RainfallProvider";
import {
  openWindowsRainfallMap,
  rainfallMap,
} from "../../mainLayer/rainfall/Rainfall";
import RainfallPopup from "../../mainLayer/rainfall/RainfallPopup";
import SideRainDayChart from "../../mainLayer/rainfall/SideRainDayChart";
import SideRainCurrentChart from "../../mainLayer/rainfall/SideRainCurrentChart";
import SideRainDiffChart from "../../mainLayer/rainfall/SideRainDiffChart";

type SideMenuPopupsType = {
  id: string | null;
  name: string | null;
  // critical: number| null;
  // cautious: number| null;
  // warning: number| null;
  setPopups: Dispatch<React.SetStateAction<PopupsListType[]>>;
  widthValue: number;
  setRainfallRender: () => void;
  removeItem: (id: string, type: ItemTypes) => void;
  addItem: (id: string, type: ItemTypes) => void;
  coordinatesPopup: Coordinate;
};

const SideMenuRainfallPopup = (props: SideMenuPopupsType) => {
  const [lastUpdate, setLastUpdate] = useState<string | null>(null);
  const date = new Date().toLocaleDateString();
  const time = new Date().toLocaleTimeString();
  const [widthMain, setWidthMain] = useState<number>(0);
  const [heightMain, setHeightMain] = useState<number>(0);
  const [isDark, setIsDark] = useState<boolean>(false);
  const { RainfallOpenSidebarMap, removeFromRainfallOpenSidebarMap } =
    useRainfallContext();

  const [current, setCurrent] = useState<string>("");
  const [last24, setLast24] = useState<string>("");
  const [diff, setDiff] = useState<string>("");

  const [dimensions, setDimensions] = useState({
    resizableBoxwidth: 0,
    resizableBoxheight: 0,
  });

  const [dimensionsMin, setDimensionsMin] = useState({
    resizableBoxMinwidth: 0,
    resizableBoxMinheight: 0,
  });

  //----------------resibleBox Function----------------

  const updateDimensions = () => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    if (vw > 2000 && vh > 1200) {
      setDimensions({
        resizableBoxwidth: vw * 0.4,
        resizableBoxheight: vh * 0.5,
      });
    } else {
      setDimensions({
        resizableBoxwidth: vw * 0.68,
        resizableBoxheight: vh * 0.8,
      });
    }

    if (vw > 2000 && vh > 1200) {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.2,
        resizableBoxMinheight: vh * 0.3,
      });
    } else {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.3,
        resizableBoxMinheight: vh * 0.4,
      });
    }
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const RAIN_DATA_URL = process.env.REACT_APP_RAIN_DATA_URL;
  const RAIN_24H_URL = process.env.REACT_APP_RAIN_24H_URL;
  const RAIN_DIFF_URL = process.env.REACT_APP_RAIN_DIFF_URL;

  useEffect(() => {
    const fetchCurrentSensorsData = async () => {
      try {
        const response = await fetch(
          `${RAIN_DATA_URL}`+
            props.id
        );
        const responseData = await response.json();

        if (responseData && typeof responseData === "object") {
          const { time, level } = responseData;
          setLastUpdate(time);
          setCurrent(level);
        } else {
          console.error("Invalid response data format:", responseData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const fetchlast24SensorsData = async () => {
      try {
        const response = await fetch(
        `${RAIN_24H_URL}`+
            props.id
        );
        const responseData = await response.json();

        if (responseData && typeof responseData === "object") {
          const { level } = responseData;
          setLast24(level);
        } else {
          console.error("Invalid response data format:", responseData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const fetchDiffData = async () => {
      try {
        const response = await fetch(
         `${RAIN_DIFF_URL}` +
            props.id
        );
        const responseData = await response.json();

        if (responseData && typeof responseData === "object") {
          const { level } = responseData;
          setDiff(level);
        } else {
          console.error("Invalid response data format:", responseData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCurrentSensorsData();
    fetchlast24SensorsData();
    fetchDiffData();
    return () => {};
  }, [props.id]);

  useEffect(() => {
    setWidthMain(props.widthValue);
  }, [props.widthValue, widthMain, heightMain]);

  const removeRainfallById = (id: string) => {
    if (rainfallMap.has(id)) {
      rainfallMap.delete(id);
      openWindowsRainfallMap.set(id, "close");
      props.setRainfallRender();
    }
    openMarkers.set(id, false);
    removeOverlay(id);
    removeFromRainfallOpenSidebarMap(id);
    if (RainfallOpenSidebarMap.has(id)) {
      RainfallOpenSidebarMap.delete(id);
    }
  };

  useEffect(() => {
    const entries = Array.from(RainfallOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  }, [RainfallOpenSidebarMap.size]);

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);

  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("rain");

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX) {
          ReactDOM.render(
            <RainfallPopup
              sensorId={props.id!}
              name={props.name!}
              // cautionLevel={props.cautious!}
              // warningLevel={props.warning!}
              // criticalLevel={props.critical!}
              addItem={props.addItem}
              id={props.id!}
              onClose={handleClose}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(props.coordinatesPopup);
          map.addOverlay(overlay);
          props.removeItem(props.id!, "rain");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

         
        const touchX = event.touches[0].clientX; // Get touch position
  
        if (sideMenuWidth > touchX) {
          ReactDOM.render(
            <RainfallPopup
              sensorId={props.id!}
              name={props.name!}
              // cautionLevel={props.cautious!}
              // warningLevel={props.warning!}
              // criticalLevel={props.critical!}
              addItem={props.addItem}
              id={props.id!}
              onClose={handleClose}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(props.coordinatesPopup);
          map.addOverlay(overlay);
          props.removeItem(props.id!, "rain");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const handleClose = (sensorId: string) => {
    openWindowsRainfallMap.set(sensorId, "close");

    if (rainfallMap.has(sensorId)) {
      rainfallMap.delete(sensorId);
    }
    removeFromRainfallOpenSidebarMap(sensorId);
    if (RainfallOpenSidebarMap.has(sensorId)) {
      RainfallOpenSidebarMap.delete(sensorId);
    }
  };

  useEffect(() => {
  }, [RainfallOpenSidebarMap.size]);

  useEffect(() => {
      const handleMouseDown = () => {
        document.addEventListener("mousemove", mouseMoveEvent);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    
      const handleTouchStart = () => {
        document.addEventListener("touchmove", mouseMoveEventTouch);
        document.addEventListener("touchend", handleTouchEnd);
      };
    
      const handleTouchEnd = () => {
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    
      if (popupRef.current) {
        popupRef.current.addEventListener("mouseenter", () => {
          popupRef.current?.addEventListener("mousedown", handleMouseDown);
          popupRef.current?.addEventListener("touchstart", handleTouchStart);
        });
      }
    
      return () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [mouseMoveEvent, mouseMoveEventTouch]);

  //   useEffect(() => {
  //     const handleMouseDown = () => {
  //         document.addEventListener('mousemove', mouseMoveEvent);
  //         document.addEventListener('mouseup', handleMouseUp);
  //     };
  
  //     const handleMouseUp = () => {
  //         document.removeEventListener('mousemove', mouseMoveEvent);
  //     };
  
  //     if (popupRef.current) {
  //         popupRef.current.addEventListener('mouseenter', () => {
  //             popupRef.current?.addEventListener('mousedown', handleMouseDown);
  //         });
  //     }
  
  //     return () => {
  //         document.removeEventListener('mousemove', mouseMoveEvent);
  //         document.removeEventListener('mouseup', handleMouseUp);
  //     };
  // }, [mouseMoveEvent])

  // const handleClose = (incidentId: string) => {
  //   openWindowsMap.set(incidentId, "close");
  // };

  return (
    <div
      className={`popup`}
      style={{ visibility: `${isNotRelease ? "visible" : "hidden"}` }}
      ref={popupRef}

      
    >
      <div className={`titleWrapper  `}>
        <span>{props.name}</span>
        <div className={`titleButtonContainer`}>
          <i
            className={`titleIcon closeIco no-drag`}
            onClick={(e) => {
              if (props.id !== null) {
                removeRainfallById(props.id);
              }
            }}
            
            onTouchStart={(e) => {
              if (props.id !== null) {
                removeRainfallById(props.id);
              }
            }}
          ></i>
        </div>
      </div>

      <div className={`rainfall-container`}>
        <div className={`chart-container`}>
          <div className={`chart1-wrapper no-drag`}>
            <SideRainDayChart
              id={props.id!}
              showDialog={true}
              chartWidth={
                widthMain > 1000 ? widthMain * 0.65 : widthMain * 0.85
              }
              chartHeight={300}
              setLastUpdate={setLastUpdate}
              currentDay={"Current Rainfall"}
              differant={"Differance"}
            />
          </div>
          <div className={`chart2-wrapper  no-drag`}>
            <SideRainCurrentChart
              id={props.id!}
              showDialog={true}
              chartWidth={
                widthMain > 1000 ? widthMain * 0.65 : widthMain * 0.85
              }
              chartHeight={300}
              setLastUpdate={setLastUpdate}
            />
          </div>
          <div className={`chart3-wrapper  no-drag`}>
            <SideRainDiffChart
              id={props.id!}
              showDialog={true}
              chartWidth={
                widthMain > 1000 ? widthMain * 0.65 : widthMain * 0.85
              }
              chartHeight={300}
              setLastUpdate={setLastUpdate}
            />
          </div>
        </div>
        {/* <div className={`color-bar`}>
        <div className={`legendItem`}>
            <i className={`colorBox`} style={{backgroundColor: '#0275d8'}}></i>
            <span>river level</span>
        </div>
        <div className={`legendItem`}>
            <i className={`colorBox`} style={{backgroundColor: '#d9534f'}}></i>
            <span>danger level</span>
        </div>
        <div className={`legendItem`}>
            <i className={`colorBox`} style={{backgroundColor: '#eb9824'}}></i>
            <span>warning level</span>
        </div>
        <div className={`legendItem`}>
            <i className={`colorBox`} style={{backgroundColor: '#e4e736'}}></i>
            <span>cautious level</span>
        </div>
    </div> */}

        <div className={`data-bar`}>
          <div className={`detailItem`}>
            <span className={`label`}>Current: </span>
            <span className={`data`}>{current} mm</span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>Diff: </span>
            <span className={`data`}>{diff} mm</span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>24h: </span>
            <span className={`data`}>{last24} mm</span>
          </div>
        </div>
        <div className={`data2-bar`}>
          <div className={`detailItem`}>
            <span className={`label`}>Last data: </span>
            <span className={`data`}>{lastUpdate}</span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>Last update on: </span>
            <span className={`data`}>{lastUpdate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideMenuRainfallPopup;
